export enum Site {
  GET_SITE_REQUEST = '@site/GET_SITE_REQUEST',
  GET_SITE_SUCCESS = '@site/GET_SITE_SUCCESS',
  GET_SITE_FAIL = '@site/GET_SITE_FAIL',

  GET_SITE_BALANCE_REQUEST = '@site/GET_SITE_BALANCE_REQUEST',
  GET_SITE_BALANCE_SUCCESS = '@site/GET_SITE_BALANCE_SUCCESS',
  GET_SITE_BALANCE_FAIL = '@site/GET_SITE_BALANCE_FAIL',

  CLEAR_SITE = '@site/CLEAR_SITE',
}
